/**
 * Width / height ratios for crop aspect preset keys.
 * Keep in sync with AssetsCopyCropPreview ASPECT_BY_KEY, server hasValidCropAspect,
 * and zipper normalizedCropFromAspect / computeCropRegion.
 */
export const CROP_ASPECT_RATIO_BY_KEY = {
  '1:1': 1,
  '4:3': 4 / 3,
  '3:4': 3 / 4,
  '4:5': 4 / 5,
  '16:9': 16 / 9,
  '9:16': 9 / 16,
  '1.91:1': 1.91,
  '2.27:1': 2.27,
  '3:1': 3,
  '4:1': 4,
  '5.9:1': 5.9,
};

/** @returns {number|null} width / height, or null for original / free / unknown */
export function getCropAspectRatio(presetKey) {
  if (!presetKey || presetKey === 'original' || presetKey === 'free') {
    return null;
  }
  const ratio = CROP_ASPECT_RATIO_BY_KEY[presetKey];
  return typeof ratio === 'number' && ratio > 0 ? ratio : null;
}
